import { render, staticRenderFns } from "./bottomHome.vue?vue&type=template&id=328ed018&"
import script from "./bottomHome.vue?vue&type=script&lang=js&"
export * from "./bottomHome.vue?vue&type=script&lang=js&"
import style0 from "./bottomHome.vue?vue&type=style&index=0&id=328ed018&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports